import React from 'react'
import './login.css'
import GeneForm from './GeneForm.js';
import './login.css'

const GeneCode = () => {
    return (
        <section id="hero" className="d-flex align-items-center justify-content-center" style={{backgroundColor: '#dfe2ea', top: "center", width: '100%'}}>
            <div className="container custom-sm" data-aos="fade-up">
                <div className="justify-content-center align-items-center rounded-4" data-aos="zoom-in" data-aos-delay="250">
                    <GeneForm/>
                </div>
            </div>
        </section>
    )
}

export default GeneCode